import styled from 'astroturf/react'
import PropTypes from 'prop-types'
import { Icon } from '@calendly/ui/components/icon'
import _RoundIcon from "RoundIcon.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/round_icon.js?styleId=RoundIcon";

const colorBgWhiteL1 = 'var(--color-bg-white-l-1, rgba(255, 255, 255, 1))'

const RoundIcon = /*#__PURE__*/styled(Icon, null, {
  displayName: "RoundIcon",
  styles: _RoundIcon,
  attrs: props => ({
    ...props,
    size: 'standard'
  })
})

RoundIcon.propTypes = {
  name: PropTypes.string.isRequired,
  size: PropTypes.oneOf(['xsmall', 'small', 'standard', 'large', 'xlarge']),
}

export default RoundIcon
